export const isServer = import.meta.server
export const spritePaths = Object.freeze({
  "default": "/_nuxt/nuxt-svg-icon-sprite/sprite-default.Jk9OWzAy41fEC_SKV93iDN0X2HyKpHppiQGuo5JTL_U.svg"
});
export const runtimeOptions = Object.freeze({
  "ariaHidden": false
});
export const allSymbolNames = Object.freeze([
  "add-hexagon",
  "aoz",
  "arrow-left",
  "arrow-right",
  "chevron-down",
  "chevron-down-menu",
  "chevron-left",
  "chevron-right",
  "close",
  "facebook",
  "icon-arrow-down",
  "icon-arrow-right",
  "info",
  "instagram",
  "link-default",
  "linkedin",
  "logo",
  "magnifyingglass",
  "newspaper",
  "paperplane",
  "person",
  "play",
  "play-alt",
  "refresh"
]);